import * as React from 'react';
import { trainer } from '../../../model/trainer';
import DeletableLabelButton from '../../../ui-components/Button/DeletableLabelButton';

interface IProps {
    trainer: trainer;
    removeTrainer: (id: string) => any;
    disabled?: boolean;
}
export const TrainerDisplay = (props: IProps) => {
    return <DeletableLabelButton disabled={props.disabled} text={props.trainer.name} onremove={() => props.removeTrainer(props.trainer._id)} />
}